/**
 * @file science Hooks
 * @author v_duzhengqiang
 */

import { useState } from 'react';
import { useMount } from 'react-use';
import { getCmsDataInfo } from '../../api/pages/paddleCmsGetDataApi';
import {
    RootObject
} from './type';


const useEasyDeployHooks = () => {
    const [loading, setLoading] = useState<boolean>(false);
    // 数据
    const [data, setData] = useState<RootObject>(
        {
            easyDeployHeader: {
                easyDeployHeaderTitle: "",
                easyDeployHeaderContent: "",
                easyDeployHeaderJumpContent: [],
                description: ""
            },
            easyDeployIntro: {
                content: []
            },
            easyDeployDescribe: {
                easyDeployDescribeTitle: '',
                description: '',
                content: []
            },
            easyDeployFotter: {
                easyDeployFotterTitle: "",
                easyDeployFotterContent: [],
                description: ""
            },
            qrCode: {
                qrCodeTitle: "",
                qrCodeDesc: "",
                backImg: "",
                stepsOne: "",
                stepsTwo: "",
                description: ""
            }
        }
    );

    useMount(() => {
        (async () => {
            setLoading(true)
            const res = await getCmsDataInfo({ requestUrl: '/easy_deploy' })
            .finally(() =>setLoading(false));
            if (res) {
                const data = res.body.result?.pageData || {};
                data && setData(data);
            }
        })();
    });
    return {
        data,
        loading
    }
}

export default useEasyDeployHooks;